

export default function Button({ children, icon: Icon, onClick, style ,className }) {
  return (
    <button
      style={style}
      onClick={onClick}
      className={`border-0 d-flex justify-content-center align-item-center ${className} `}
    >
      {children}
      {Icon && <Icon size={18} />}
    </button>
  );
}
